import React from 'react';
import Icon from '../AppIcon';

/**
 * A rating stars component for displaying or selecting ratings
 * @param {Object} props
 * @param {number} props.value - Current rating value (1-5)
 * @param {Function} props.onChange - Callback when rating changes
 * @param {boolean} props.readonly - Whether the rating is read-only
 * @param {number} props.max - Maximum rating value (default: 5)
 * @param {string} props.size - Size of stars (sm, md, lg)
 * @param {string} props.activeColor - Color of active stars
 * @param {string} props.inactiveColor - Color of inactive stars
 */
const RatingStars = ({
  value = 0,
  onChange,
  readonly = false,
  max = 5,
  size = 'md',
  activeColor = 'text-warning',
  inactiveColor = 'text-text-muted'
}) => {
  // Map size to icon size
  const sizeMap = {
    sm: 16,
    md: 20,
    lg: 24
  };
  
  const iconSize = sizeMap[size] || sizeMap.md;

  const handleClick = (newValue) => {
    if (readonly) return;
    onChange?.(newValue);
  };

  const handleMouseEnter = (_index) => {
    // For future hover functionality
  };

  const renderStar = (index) => {
    const starValue = index + 1;
    const filled = starValue <= value;
    
    return (
      <button
        key={index}
        type="button"
        onClick={() => handleClick(starValue)}
        onMouseEnter={() => handleMouseEnter(index)}
        className={`focus:outline-none ${filled ? activeColor : inactiveColor} transition-colors ${
          readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'
        }`}
        disabled={readonly}
        aria-label={`${starValue} star${starValue !== 1 ? 's' : ''}`}
      >
        <Icon name="Star" size={iconSize} fill={filled ? 'currentColor' : 'none'} />
      </button>
    );
  };

  return (
    <div className="inline-flex items-center space-x-1">
      {[...Array(max)].map((_, index) => renderStar(index))}
    </div>
  );
};

export default RatingStars;
